import React, { useEffect, useState } from "react";
import {
    Wrapper,
    WorkOrderWrapper,
    CommentsWrapper,
    WorkOrderInfoWrapper,
    WorkOrderActivityWrapper,
    ButtonWrapper
} from "./styled";
import Layout from "../Layout";
import {
    AppContext,
    date,
    getLabel,
    getRoleDetails
} from "hocs/withAppContext";
import { addComment, getSharedWorkOrder } from "./service";
import Loader from "components/UpkeepLoaderTripleGear";
import WorkOrderStatusBar from "./WorkOrderStatusBar";
import { ReactComponent as AvatarIcon } from "assets/svgs/profile.svg";
import {
    EmailInput,
    TextAreaInput,
    CheckboxInput
} from "components";

const Activity = ({ update }) =>
    <ul>
        <span>{update.text}</span>
        <span>{date(update.createdAt)}</span>
    </ul>;

const Comment = ({ comment }) =>
    <ul>
        <div>
            <span>{comment.email}</span>
            <span>{date(comment.createdAt)}</span>
        </div>
        <span>{comment.text}</span>
    </ul>;

const CommentForm = ({ workOrderId, setWorkOrder }) => {
    const defaultCommentData = {
        email: '',
        message: '',
        subscribe: true
    };
    const [data, setData] = useState(defaultCommentData);

    const set = (name, value) => setData({ ...data, [name]: value });
    const handleOnSubmit = () =>
        addComment(workOrderId, data)
            .then(setWorkOrder)
            .then(() => setData({...data, message: ''}));

    return <div>
        <EmailInput
            placeholder="Your email address"
            value={data.email}
            onChange={val => set("email", val)}
        />
        <TextAreaInput
            placeholder="Add a comment"
            rows={6}
            value={data.message}
            onChange={val => set("message", val)}
        />
        <CheckboxInput
            label="Get email updates"
            value={data.subscribe}
            onChange={val => set("subscribe", val)}
        />
        <ButtonWrapper onClick={handleOnSubmit}>Send</ButtonWrapper>
    </div>;
};

const SharedWorkOrder = ({ match }) => {
    const workOrderId = match.params.id;
    const [role, setRole] = useState({});
    const [workOrder, setWorkOrder] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getSharedWorkOrder(workOrderId)
            .then(workOrder => {
                setWorkOrder(workOrder);
                getRoleDetails(workOrder.role.objectId)
                    .then(setRole);
            })
            .then(() => setLoading(false));
    }, [workOrderId]);

    const context = {
        role: role,
        n: (label) => getLabel(label, role.companyBusinessType)
    };

    if (loading) {
        return <Loader/>;
    }

    // createdBy calculation varies across fields
    // for public requests - requesterEmailAddress
    // for internal requests - userObjectIdFirstCreated
    // for normal W.O - objectAssignedBy
    const { objectAssignedBy, stringAssignedBy, requesterEmailAddress } = workOrder;
    const createdBy = (objectAssignedBy && objectAssignedBy.firstName)
        ? `${objectAssignedBy.firstName} ${objectAssignedBy.lastName}`.trim()
        : (stringAssignedBy || requesterEmailAddress);
    const createdByAvatar = (objectAssignedBy && objectAssignedBy.userImageFile)
        ? objectAssignedBy.userImageFile.url : '';

    // userAssignedTo can contain a deleted user
    // and hence no user info
    // fallback to `usernameStringAssignedTo`
    const { userAssignedTo, usernameStringAssignedTo } = workOrder;
    const assignedTo = (userAssignedTo && userAssignedTo.firstName)
        ? `${userAssignedTo.firstName} ${userAssignedTo.lastName}`.trim()
        : usernameStringAssignedTo;
    const assignedToAvatar = (userAssignedTo && userAssignedTo.userImageFile)
        ? userAssignedTo.userImageFile.url : '';

    const activities = workOrder.arrayOfUpdateItems
        .filter(update => update.source !== "public_share")
        .map(update => <Activity update={update}/>);
    const comments = workOrder.arrayOfUpdateItems
        .filter(comment => comment.source === "public_share")
        .map(comment => <Comment comment={comment}/>);

    return (
        <AppContext.Provider value={context}>
            <Layout>
                <Wrapper>
                    <WorkOrderWrapper>
                        <WorkOrderStatusBar status={workOrder.currentStatus}/>
                        <WorkOrderInfoWrapper>
                            <h1>{workOrder.mainDescription}</h1>
                            <div className="sub">
                                <span>#{workOrder.workOrderNumber}</span>
                                { workOrder.dueDate && <span>Due {date(workOrder.dueDate.iso)}</span> }
                            </div>

                            <p>{workOrder.note}</p>

                            <div className="profiles">
                                <div>
                                    {createdByAvatar
                                        ? <img src={createdByAvatar} alt={createdBy}/>
                                        : <AvatarIcon/>
                                    }
                                    <div>
                                        <span>Created By</span>
                                        <span>{createdBy}</span>
                                    </div>
                                </div>

                                <div>
                                    {assignedToAvatar
                                        ? <img src={assignedToAvatar} alt={assignedTo}/>
                                        : <AvatarIcon/>
                                    }
                                    <div>
                                        <span>Assigned To</span>
                                        <span>{assignedTo}</span>
                                    </div>
                                </div>
                            </div>
                        </WorkOrderInfoWrapper>
                        <WorkOrderActivityWrapper>
                            <h2>Activity</h2>
                            <li>{activities}</li>
                        </WorkOrderActivityWrapper>
                    </WorkOrderWrapper>

                    <CommentsWrapper>
                        <h2>Comments</h2>
                        <li>{comments}</li>
                        <CommentForm
                            workOrderId={workOrderId}
                            setWorkOrder={setWorkOrder}
                        />
                    </CommentsWrapper>
                </Wrapper>
            </Layout>
        </AppContext.Provider>
    );
};

export default SharedWorkOrder;
